import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=ad948bd4"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=ad948bd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports